import { useEffect, useEffectEvent, useState } from "react"
import { Control, SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"

import DataListModal from "../../DataModals/DataListModal" 

import * as Basic from "../../../Modules/BasicFields"

const survivorVariables = [
    {name:'Top ranked', key:'top_ranked', type:'W'},
]

export default function Survivor( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg
    const modalOpen = props.modalOpen
    const selected = props.selected
    const reset = props.reset

    const [ hashtag, setHashtag ] = useState(null)
    const [ font, setFont ] = useState(null)
    const [ votingRate, setVotingRate ] = useState(null)
    const [ progressbarColor, setProgressbarColor ] = useState(null)
    const [ variables, setVariables ] = useState(null)
    const [ list, setList ] = useState(null)
    const [ resetHashtag, setResetHashtag ] = useState(null)
    const [ stepDuration, setStepDuration ] = useState(null)

    const [ showModal, setShowModal ] = useState(false)

    const requiredData = [
        hashtag,
        font,
        variables,
        progressbarColor,
        variables,
        list,
        resetHashtag,
        stepDuration
    ]

    const cfgName = "consensus_survivor_cfg"
    

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setFont( cfg.font || {})
        setHashtag( cfg.hashtag || "" )
        setVotingRate( cfg.voting_rate || "one_per_user")
        setProgressbarColor( cfg.progressbar_color || { r: 255, g: 0, b: 0, a: 1.0 })
        setVariables( cfg.variables || {} )
        setList( cfg.list || [] )
        setResetHashtag( cfg.reset_hashtag || "")
        setStepDuration( (cfg.step_duration != null) ? cfg.step_duration : 120 )
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {

        if( requiredData.includes(null) )
        {
            return
        }

        let data = {}
        data.font = font 
        data.hashtag = hashtag
        data.voting_rate = votingRate
        data.variables = variables
        data.list = list
        data.progressbar_color = progressbarColor
        data.reset_hashtag = resetHashtag
        data.step_duration = stepDuration

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ font, variables, list, progressbarColor, hashtag, votingRate, resetHashtag, stepDuration ])

    useEffect( () => {
        modalOpen.current = showModal
    },[showModal])

    const addToList = ( text ) => {
        if( text == "" )
        {
            return 
        }

        let pp = structuredClone(list)
        pp.push( text )

        setList(pp)
    }

    const removeFromList = (idx) => {
        let pp = structuredClone(list)
        pp.splice(idx,1)
        setList(pp)
    }

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <SettingsGroup name="Behaviour">
                <Basic.ButtonInput name="Edit voting list" onClick={ e => setShowModal(true)} />
                <Basic.StringInput name="Hashtag" value={hashtag} setValue={setHashtag}/>
                <Basic.SelectInput name="Voting rate" value={votingRate} setValue={setVotingRate} 
                                   options={[
                                { label: "One per user", value: "one_per_user" },
                                { label: "One every 10 seconds", value: "one_every_10_seconds" },
                                { label: "One every minute", value: "one_every_minute" },
                                { label: "Unlimited", value: "unlimited" },
                            ]}
                />
                <Basic.PositiveIntegerInput name="Step duration" value={stepDuration} setValue={setStepDuration} />
            </SettingsGroup>
            <SettingsGroup name="Visual Customization">
                <Basic.ColorInput name="Bar color" value={progressbarColor} setValue={setProgressbarColor} />
            </SettingsGroup>

            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            />
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={survivorVariables}
                            reset={reset}
            />

            <SettingsGroup name="Remote Control">
                <Basic.StringInput name="Reset hashtag" value={resetHashtag} setValue={setResetHashtag} />
            </SettingsGroup>
            
            <DataListModal modalTitle="Voting list"
                           showModal={showModal}
                           setShowModal={setShowModal}
                           modalOpen={modalOpen}
                           list={list}
                           setList={setList}
            />
        </>
    )
}

